var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddingAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.2816L4.69056 7.40281C4.28513 7.78519 3.73525 8 3.16188 8C2.58851 8 2.03863 7.78519 1.6332 7.40281C1.22777 7.02044 1 6.50183 1 5.96108C1 5.42032 1.22777 4.90171 1.6332 4.51934L4.94264 1.39812C5.21293 1.14321 5.57952 1 5.96176 1C6.344 1 6.71059 1.14321 6.98088 1.39812C7.25117 1.65304 7.40301 1.99878 7.40301 2.35928C7.40301 2.71979 7.25117 3.06553 6.98088 3.32044L3.66784 6.44166C3.5327 6.56911 3.3494 6.64072 3.15828 6.64072C2.96716 6.64072 2.78386 6.56911 2.64872 6.44166C2.51358 6.3142 2.43765 6.14133 2.43765 5.96108C2.43765 5.78082 2.51358 5.60796 2.64872 5.4805L5.70608 2.60042",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddingAttachmentIcon);
export default __webpack_public_path__ + "static/media/Adding-Attachment-Icon.f3aaa13b619a8d20dbd38aad7aad7d84.svg";
export { ForwardRef as ReactComponent };